import { useBreadcrumb } from '~/components/layout/Breadcrumb';
import { PageLoader } from '~/components/page/PageLoader';

export default function DocumentsRoute() {
  useBreadcrumb('routes/documents', 'Documents');
  return <PageLoader pageName="documents" />;
}
